<template>
  <nav class="t-tabs" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      role="tab"
      class="t-tab"
      :class="{ active: activeTab == tab.id }"
      :aria-selected="activeTab == tab.id ? 'true' : 'false'"
      :title="tab.short ? tab.label : null"
      @click="setActiveTab(tab.id)"
    ><span class="t-tab-icon"><tkd-icon :name="tab.icon"/></span><span class="t-tab-label" :class="{ 'has-short': tab.short }">{{ tab.label }}</span><span class="t-tab-short" v-if="tab.short">{{ tab.short }}</span></button>
  </nav>
</template>

<script>
  import 'src/assets/css/tkd-theme.css';

  const TAB_QUERY_BY_ID = {
    1: 'info',
    2: 'sportsmans',
    4: 'drawing',
    6: 'results',
    7: 'categories',
    11: 'numeration',
    12: 'badges',
    13: 'devices',
    14: 'fights',
  };

  export default {
    name: "control-tabs",
    data() {
      return {
        tabs: [
          { id: 1, label: 'Загальна інформація', short: 'Інформація', icon: 'stats' },
          { id: 7, label: 'Категорії', icon: 'belt' },
          { id: 2, label: 'Спортсмени', icon: 'dobok' },
          { id: 4, label: 'Жеребкування', icon: 'bracket' },
          { id: 14, label: 'Поєдинки', icon: 'kyorugi' },
          { id: 6, label: 'Результати', icon: 'trophy' },
          { id: 11, label: 'Нумерація', icon: 'numbering' },
          { id: 12, label: 'Бейджі', icon: 'badge' },
          { id: 13, label: 'Електронна система', short: 'Е-система', icon: 'referee' },
        ]
      }
    },
    watch: {
      // на телефоні таби в один рядок з прокруткою — показуємо активну
      activeTab() {
        this.$nextTick(() => this.scrollActiveIntoView());
      },
    },
    mounted() {
      this.scrollActiveIntoView();
    },
    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },
      activeCategoryId() {
        return this.$store.getters['settings/activeCategoryId'];
      },
    },
    methods:{
      scrollActiveIntoView() {
        const nav = this.$el;
        const active = nav && nav.querySelector('.t-tab.active');
        if (!active || nav.scrollWidth <= nav.clientWidth) return;
        // лише горизонтально в межах табів, сторінку не крутимо
        const left = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
        nav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      },
      setActiveTab(position) {
        this.keepTabsPinned();
        this.$store.dispatch('settings/setActiveTournamentTab', position);
        const tabQueryValue = TAB_QUERY_BY_ID[position];
        if (!tabQueryValue || this.$route.query.tab === tabQueryValue) {
          return;
        }

        if (position === 4 && this.$route.params.id && Number(this.activeCategoryId) > 0) {
          this.$router
            .push({
              path: `/user/tournaments/overview/${this.$route.params.id}/bracket/${this.activeCategoryId}`,
              query: {
                ...this.$route.query,
                tab: tabQueryValue,
              },
            })
            .catch(() => {});
          return;
        }

        // push — щоб кнопки Назад/Вперед браузера перемикали таби
        this.$router
          .push({
            query: {
              ...this.$route.query,
              tab: tabQueryValue,
            },
          })
          .catch(() => {});
      },
      // якщо таби закріплені — після перемикання показуємо початок нової таби під ними
      keepTabsPinned() {
        let stickyTop = parseFloat(getComputedStyle(this.$el).top) || 0;
        if (this.$el.getBoundingClientRect().top > stickyTop + 1) {
          return;
        }
        let anchor = this.$el.previousElementSibling;
        if (!anchor) {
          return;
        }
        this.$nextTick(() => {
          let marginTop = parseFloat(getComputedStyle(this.$el).marginTop) || 0;
          let pinnedScroll = anchor.getBoundingClientRect().bottom + window.pageYOffset + marginTop - stickyTop;
          window.scrollTo(0, pinnedScroll);
        });
      },
      // setActiveTab(position) {
      //   console.log('setActiveTab ' + position);
      //   this.activeTab = position;
      //   Cookie.set("tab_in_"+this.id, position);
      // },
    }
  }
</script>

<style scoped>
  .t-tabs {
    position: sticky;
    top: 8px;
    z-index: 900;
    display: flex;
    gap: 4px;
    margin: 20px 0;
    padding: 5px;
    border-radius: var(--tkd-radius);
    background: var(--tkd-surface);
    border: 1px solid var(--tkd-border);
    /* друга тінь закриває контент у відступі над закріпленими табами */
    box-shadow: var(--tkd-shadow), 0 -8px 0 4px var(--tkd-bg);
    overflow-x: auto;
    scrollbar-width: thin;
    font-family: var(--tkd-font);
  }

  .t-tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    height: 42px;
    padding: 0 16px;
    border: 0;
    border-radius: 9px;
    background: transparent;
    font-size: 14px;
    font-weight: 600;
    color: var(--tkd-muted);
    white-space: nowrap;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }

  .t-tab:hover { color: var(--tkd-text); background: var(--tkd-bg); }
  .t-tab.active { color: #fff; background: var(--tkd-gradient-btn); box-shadow: 0 4px 12px rgba(0, 87, 183, 0.3); }
  .t-tab:focus-visible { outline: 2px solid var(--tkd-blue); outline-offset: 1px; }
  .t-tab-icon { font-size: 15px; }
  .t-tab-short { display: none; }

  /* менші екрани: компактніше і короткі назви */
  @media (max-width: 1440px) {
    .t-tab { gap: 6px; padding: 0 11px; font-size: 13px; }
    .t-tab-label.has-short { display: none; }
    .t-tab-short { display: inline; }
  }

  /* усі таби видно: переносимо на другий рядок і рівномірно розтягуємо */
  @media (max-width: 1200px) and (min-width: 768px) {
    .t-tabs { flex-wrap: wrap; overflow-x: visible; }
    .t-tab { flex: 1 1 auto; justify-content: center; height: 38px; }
  }

  /* телефон: один рядок з прокруткою, активний таб — по центру (scrollActiveIntoView).
     без mask-image: вона обрізала б тінь, що закриває контент над закріпленими табами */
  @media (max-width: 767px) {
    .t-tabs {
      margin: 12px 0;
      scroll-snap-type: x proximity;
      scrollbar-width: none;
    }
    .t-tabs::-webkit-scrollbar { display: none; }
    .t-tab { height: 38px; padding: 0 12px; scroll-snap-align: center; }
  }

  @media (prefers-reduced-motion: reduce) {
    .t-tab { transition: none; }
  }
</style>
